import { Alert } from "antd";
import { Component } from "react";
class AppAlert extends Component {
    render() {
        return <Alert {...this.props}>{this.props.children}</Alert>
    }
}
export default AppAlert;